<template>
  <div>
    <h1>Lista zamówień</h1>

    <v-row>
      <v-col class="pr-2" md="3" cols="12">
        <v-text-field placeholder="Szukaj" v-model="search" />
      </v-col>
      <v-col class="px-2" md="3" cols="12">
        <v-combobox :items="itemsFilterType" label="Usługi" multiple placeholder="Wszystkie" small-chips v-model="filterType" />
      </v-col>
      <v-spacer />
      <v-col class="pl-2" md="6" cols="12">
        <v-combobox :items="itemsFilterStatus" label="Status" multiple placeholder="Wszystkie" small-chips v-model="filterStatus" />
      </v-col>
    </v-row>

    <v-data-table
      :loading="$store.getters['Ajax/loading'] ? 'accent' : false"
      :custom-filter="filterOverAllProperty"
      :headers="headers"
      :items="orders"
      :search="search"
      class="table-less-padding"
      dense
      :sort-by.sync="pagination.sortBy"
      :sort-desc.sync="pagination.descending"
      :items-per-page="5"
    >
      <template #item="{item}">
        <tr>
          <td>{{ item.company_name }}</td>
          <td>{{ item.created_by_name }}</td>
          <td>{{ item.created_at }}</td>
          <td>
            <v-row>
              <v-col lg="6" v-if="item.items.filter(v => v.type === 'hotel').length > 0" md="12" class="py-0">
                <h4>Hotele</h4>

                <single-service-order-chip
                  :status="hotel.status"
                  :key="hotel.id"
                  :text="'Usługa zakwaterowania'"
                  v-for="hotel in item.items.filter(v => v.type === 'hotel')"
                />
              </v-col>
              <v-col lg="6" v-if="item.items.filter(v => v.type === 'flight').length > 0" md="12" class="py-0">
                <h4>Loty</h4>
                <single-service-order-chip
                  :status="flight.status"
                  :key="flight.id"
                  :text="'Przelot'"
                  v-for="flight in item.items.filter(v => v.type === 'flight')"
                />
              </v-col>
              <v-col lg="6" v-if="item.items.filter(v => v.type === 'rail').length > 0" md="12" class="py-0">
                <h4>Koleje</h4>
                <single-service-order-chip :status="rail.status" :text="'Koleje'" :key="rail.id" v-for="rail in item.items.filter(v => v.type === 'rail')" />
              </v-col>
              <v-col lg="6" v-if="item.items.filter(v => v.type === 'car').length > 0" md="12" class="py-0">
                <h4>Wynajem pojazdów</h4>
                <single-service-order-chip
                  :status="car.status"
                  :text="'Wynajem pojazdu'"
                  :key="car.id"
                  v-for="car in item.items.filter(v => v.type === 'car')"
                />
              </v-col>
              <v-col lg="6" v-if="item.items.filter(v => v.type === 'insurance').length > 0" md="12" class="py-0">
                <h4>Ubezpieczenia</h4>
                <single-service-order-chip
                  :status="insurance.status"
                  :text="'Ubezpieczenie'"
                  :key="insurance.id"
                  v-for="insurance in item.items.filter(v => v.type === 'insurance')"
                />
              </v-col>
              <v-col lg="6" v-if="item.items.filter(v => v.type === 'other').length > 0" md="12" class="py-0">
                <h4>Inne usługi</h4>
                <single-service-order-chip
                  :status="other.status"
                  :key="other.id"
                  :text="'Inna usługa'"
                  v-for="other in item.items.filter(v => v.type === 'other')"
                />
              </v-col>
            </v-row>
          </td>
          <td>
            <span class="mx-1" style="text-align: center;">
              <order-chip :status="item.status" />
            </span>
          </td>
          <td v-text="item.order_group_id" />
          <td>
            <v-tooltip bottom>
              <template #activator="{on}">
                <v-btn :to="'/admin/travel-service/edit/' + item.id" icon v-on="on">
                  <v-icon>remove_red_eye</v-icon>
                </v-btn>
              </template>
              Przejdź do szczegółów zamówienia
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import SingleServiceOrderChip from "../../../components/TravelService/SingleServiceOrderChip";
import { itemsFilterStatus, itemsFilterType, singleServiceOrderStatus } from "../../../staticData/ServiceOrder";
import filterOverAllProperty from "../../../repository/filterOverAllProperty";
import OrderChip from "../../../components/TravelService/OrderChip";

export default {
  name: "AdminTravelServiceAllView",
  components: { OrderChip, SingleServiceOrderChip },
  data: () => ({
    headers: [
      { text: "Firma", value: "type" },
      { text: "Zamawiający", value: "created_by_name" },
      { text: "Utworzono", value: "created_at" },
      { text: "Usługi", value: "param", sortable: false, width: "500px" },
      // {text: 'Hotele', value: 'param', sortable: false},
      // {text: 'Loty', value: 'param', sortable: false},
      // {text: 'Koleje', value: 'param', sortable: false},
      // {text: 'Samochody', value: 'param', sortable: false},
      { text: "Status", value: "status", width: "250px" },
      { text: "Id", value: "order_group_id" },
      { text: "", value: "actions" }
    ],
    pagination: { sortBy: "created_at", descending: true },
    allOrders: [],
    search: "",
    filterStatus: [],
    filterType: []
  }),
  created() {
    this.axios.get("/admin/travel-service-admin/get-service-order-list").then(resp => {
      this.allOrders = resp.data;
    });
  },
  computed: {
    itemsFilterStatus: itemsFilterStatus,
    itemsFilterType: itemsFilterType,
    singleServiceOrderStatus: singleServiceOrderStatus,
    orders() {
      let filteredOrders = this.allOrders.filter(v => {
        if (this.filterStatus.length === 0) return true;
        for (let status of this.filterStatus) {
          if (v.status === status.value) return true;
        }
        return false;
      });
      if (this.filterType.length > 0) {
        filteredOrders = filteredOrders.filter(v => {
          for (let type of this.filterType) {
            for (let item of v.items) {
              if (item.type === type.value) return true;
            }
          }
          return false;
        });
      }

      return filteredOrders;
    }
  },
  methods: {
    filterOverAllProperty: filterOverAllProperty
  },
  mounted() {
    this.$store.dispatch("Visual/setFullPageView");
  },
  beforeDestroy() {
    this.$store.dispatch("Visual/setCenterPageView");
  }
};
</script>

<style scoped></style>
